var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalCrossShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5879 27.8602V27.8602C8.43147 26.6289 3.99999 21.2234 4 14.9451V10.6667C4 6.98477 6.98477 4 10.6667 4H21.3333C25.0152 4 28 6.98477 28 10.6667V14.945C28 21.2232 23.5687 26.6287 17.4124 27.8601H17.4121C16.4799 28.0466 15.5201 28.0466 14.5879 27.8602V27.8602Z",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.166 17.5V19.3333C18.166 20.0697 17.5691 20.6667 16.8327 20.6667H15.166C14.4296 20.6667 13.8327 20.0697 13.8327 19.3333V17.5H11.9993C11.263 17.5 10.666 16.903 10.666 16.1667V14.5C10.666 13.7636 11.263 13.1667 11.9993 13.1667H13.8327V11.3333C13.8327 10.597 14.4296 10 15.166 10H16.8327C17.5691 10 18.166 10.597 18.166 11.3333V13.1667H19.9993C20.7357 13.1667 21.3327 13.7636 21.3327 14.5V16.1667C21.3327 16.903 20.7357 17.5 19.9993 17.5H18.166Z",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCrossShield);
export default __webpack_public_path__ + "static/media/medical-cross-shield.eaf0274847dc4a421d7b395ce79bac31.svg";
export { ForwardRef as ReactComponent };